/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {registerProspectToken} from '../api'

export const useMutationRegisterProspectToken = createReactQueryMutationHook('registerProspectToken', registerProspectToken)
